import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { genericStyles, CopyText, Button } from '@buderus-apps/components'
import styles from './styles.module.scss'

const { h1 } = genericStyles

const {
  introText,
  introTextText,
  introTextSuggestions,
  introTextSuggestionsList
} = styles

type TProps = {
  handleClickSuggestion: (title: string) => void,
  isNewChat: boolean
}

const IntroText: FC<TProps> = (props) => {
  const { handleClickSuggestion, isNewChat } = props
  const { t } = useTranslation()

  const suggestions = [
    {
      index: 0,
      title: t('INTRO_QUESTION_1_TEXT')
    },
    {
      index: 1,
      title: t('INTRO_QUESTION_2_TEXT')
    },
    {
      index: 2,
      title: t('INTRO_QUESTION_3_TEXT')
    },
    {
      index: 3,
      title: t('INTRO_QUESTION_4_TEXT')
    }
  ]

  return (
    <div className={introText}>
      <h5 className={`${h1}`}>
        <span>{isNewChat ? t('NEW_CHAT_INTRO_HEADLINE') : t('INTROTEXT_HEADLINE')}</span>
      </h5>

      {!isNewChat && <>
        <div className={introTextText}>
          <CopyText>{t('INTROTEXT_1')}</CopyText>
          <CopyText>{t('INTROTEXT_2')}</CopyText>
        </div>

        <div className={introTextSuggestions}>
          <>
            <CopyText type='medium'>{t('INTROTEXT_FAMOUS_QUESTIONS')}</CopyText>
            <div className={introTextSuggestionsList}>
              {suggestions.map((suggestion) => (
                <Button key={suggestion.title} btnStyle='link-grey'
                        onClick={() => handleClickSuggestion(suggestion.title)}>{suggestion.title}</Button>
              ))}
            </div>
          </>
        </div>
      </>}
    </div>
  )
}

export default React.memo(IntroText)
